import * as React from "react"
import { Dispatch, SetStateAction } from "react"
import { set } from "react-hook-form"

interface BusinessServicesProps {
  ourServiceSelectedOption: { title: string } | undefined
  setOurServiceSelectedOption: Dispatch<
    SetStateAction<{ title: string } | undefined>
  >
}
export const BusinessServices = ({
  setOurServiceSelectedOption,
  ourServiceSelectedOption,
}: BusinessServicesProps) => {
  const data = [
    {
      title: "How often does your business need Our service?",
      options: [
        {
          title: "Weekly",
        },
        {
          title: "Monthly",
        },
        {
          title: "Quarterly",
        },
        {
          title: "Twice a year",
        },
        {
          title: "Yearly",
        },
      ],
    },
  ]
  return (
    <div className="mt-10 pt-10 container mx-auto">
      <div className="flex gap-1 justify-center">
        <h2 className="text-black lg:text-3xl text-xl font-bold text-center">
          {data[0].title}
        </h2>
        <p className="pt-2 text-black"> (Optional)</p>
      </div>
      <div className="flex lg:gap-8 gap-3 items-center mx-3 mt-10">
        {data[0].options.map((option, index) => (
          <div
            key={index}
            onClick={() =>
              setOurServiceSelectedOption(
                ourServiceSelectedOption?.title === option.title
                  ? undefined
                  : option
              )
            }
            className={`bg-real-time-options hover:border-[#7B68EC] cursor-pointer w-1/5 flex flex-col text-center items-center lg:py-3 py-2 lg:rounded-2xl rounded-lg justify-center ${
              ourServiceSelectedOption?.title === option.title
                ? "border-none bg-input"
                : ""
            }`}
          >
            <p
              className={`lg:text-sm font-semibold text-[10px] ${
                ourServiceSelectedOption?.title === option.title
                  ? "text-[#7B68EC]"
                  : " text-black"
              }`}
            >
              {option.title}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
